import axios from '@/libs/axios'

export default {
  loadTable(queryFilter) {
    let queryUrl = ''
    queryUrl = `?page=${queryFilter.page - 1}&size=${queryFilter.size}&sort=${
      queryFilter.sort
    },${queryFilter.order}`
    if (queryFilter.filter) {
      queryUrl = `/pesquisa?${queryFilter.filter}`
    }
    return axios.get(`/evento/evento_tarefas${queryUrl}`)
  },
  insertNew(data) {
    return axios.post('/evento/evento_tarefas', data)
  },
  edit(data) {
    return axios.put(`/evento/evento_tarefas/${data.id}`, data)
  },
  delete(id) {
    return axios.delete(`/evento/evento_tarefas/${id}`)
  },
}
